import { Pressable } from 'native-base';

import { Text } from '@pimm/base';
import { ComponentProps } from 'react';

type DaypartTabProps = ComponentProps<typeof Pressable> & {
  isSelected?: boolean;
  title: string;
};

export const DaypartTab = ({ isSelected, title, ...props }: DaypartTabProps) => {
  return (
    <Pressable
      rounded="lg"
      alignItems="center"
      justifyContent="center"
      px={2}
      minW="50px"
      minH={7}
      borderWidth={1}
      borderColor={isSelected ? 'blueLight.600' : 'white'}
      bg={isSelected ? 'blueLight.100' : 'white'}
      {...props}
    >
      <Text size="md">{title}</Text>
    </Pressable>
  );
};
